/**
 * Get the base URL of the API
 * @param apiUrl API URL
 * @returns URL for the base of the API
 */
export function getBaseUrl(apiUrl) {
  return new URL(apiUrl, "".concat(window.location));
}

/**
 * Get the Envoy prefix header value
 * @returns Envoy prefix header value
 */
export function getEnvoyPrefix() {
  var searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('envoyPrefix');
}
export function getConnectOptions() {
  var envoyPrefix = getEnvoyPrefix();
  return envoyPrefix != null ? {
    headers: {
      'envoy-prefix': envoyPrefix
    }
  } : {
    headers: {}
  };
}
//# sourceMappingURL=ConnectUtils.js.map